import type * as THREE from "three";
import type { PanelColor } from "../interfaces/PanelColor";
import { LeatherPanelMaterial } from "./LeatherPanelMaterial";

interface PanelMaterialProps {
  color: PanelColor;
  /** Panel size for texture scaling - ensures consistent texture scale regardless of cutouts */
  panelSize?: THREE.Vector2;
  /** Enable leather texture effect */
  textured?: boolean;
  /** Texture scale - higher values = finer grain (only for textured, overrides panelSize-based calculation) */
  textureScale?: number;
  /** Base roughness (0-1) */
  roughness?: number;
  /** Normal map intensity - higher = more visible texture (only for textured) */
  normalIntensity?: number;
  /** Texture resolution (power of 2 recommended, only for textured) */
  textureSize?: number;
}

export const PanelMaterial = ({
  color,
  panelSize,
  textured = false,
  textureScale,
  roughness = 0.4,
  normalIntensity,
  textureSize,
}: PanelMaterialProps) => {
  const metalness = color.metalic ? 0.7 : 0.5;

  // Use leather texture if enabled
  if (textured) {
    return (
      <LeatherPanelMaterial
        color={color}
        panelSize={panelSize}
        textureScale={textureScale}
        roughness={roughness}
        metalness={metalness}
        normalIntensity={normalIntensity}
        textureSize={textureSize}
      />
    );
  }

  // Fallback to simple standard material
  return (
    <meshStandardMaterial
      color={color.color}
      roughness={roughness}
      metalness={metalness}
      envMapIntensity={0.9}
    />
  );
};
